<div class="add-container">
    <div class="d-flex justify-content-between align-items-top">
        <h1 class="mb-0 pb-0" style="text-align: center;">
            <span>{{ 'Încarcă borderou - ' + name + ': ' }}</span>
            <span class="prevent-break">{{ date }}</span>
        </h1>
    </div>
    <form class="add-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="solicitare-card__upload my-3">
            <div class="solicitare-card__upload-header">
                <p class="upload-text">Fotografii/Documente</p>
                <button class="upload-btn" (click)="fileInputBorderou.click()" type="button">
                    <mat-icon class="upload-icon">cloud_upload</mat-icon>
                    ÎNCARCĂ
                </button>
            </div>
            <div class="solicitare-card__upload-files" *ngIf="
                form.value.files.length > 0 &&
                !uploading.file
            ">
                <div class="solicitare-card__upload-file" *ngFor="
                    let uploadedFile of form.value.files;
                    let i = index
              ">
                    <span class="solicitare-card__upload-file-name">
                        {{
                        uploadedFile.original_name.length > 30
                        ? (uploadedFile.original_name | slice : 0 : 30) +
                        ".."
                        : uploadedFile.original_name
                        }}
                    </span>
                    <div>
                        <button class="solicitare-card__upload-file-delete" type="button"
                            matTooltip="Șterge fișierul încărcat" (click)="removeFile(i)">
                            <img class="btn-img" src="/assets/icons/delete.svg" alt="" />
                        </button>
                    </div>
                </div>
            </div>
            <mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px" *ngIf="uploading.file"></mat-spinner>

            <input type="file" accept="image/png, image/jpeg, image/gif, image/jpg, application/pdf"
                id="upload-file-input-0" #fileInputBorderou name="fileInputBorderou" (change)="addFile($event, 'file')"
                multiple style="display: none" />
        </div>

        <div class="row mt-2">
            <div class="col d-flex justify-content-between">
                <button type="button" class="buttons" mat-flat-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" mat-flat-button color="primary" type="submit" [disabled]="form.invalid">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </div>
        </div>
        <div class="section-spinner position-absolute" *ngIf="isLoading" style="background: rgba(0, 0, 0, 0.6);">
            <div class="spinner position-absolute top-50 start-50 translate-middle">
                <mat-spinner></mat-spinner>
                <h3 class="mt-2">
                    {{ helper.dialogConfig.generalMessages.pleaseWait }}
                </h3>
            </div>
        </div>
    </form>
</div>